module.exports = __webpack_public_path__ + "static/media/88 - Ariel Pink's Haunted Graffiti - Baby (feat. DamFunk).c55673bc.mp3";